import appStore from "@/utils/store";
import { CalooAdminConfig } from "../admin";
import { isSubscribed } from "@/utils/inappPurchases";
import { requestSE } from "../request";
import { logEvent } from "@/utils/logs";

export let CalooPremium: any = appStore.get("CalooPremium") || { isPremium: false, message: "No user logged in", premiumId: null, grantedByAdmin: false, isPremiumTrial: false };

export async function updateCalooPremium() {
    CalooPremium = await checkPremiumStatus();
    console.log("📥 CalooPremium updated:", CalooPremium);
}

export async function checkPremiumStatus() {
    console.log("🔄 Checking premium status...");
    const user = appStore.get("user");
    if (!user) {
        appStore.set("calooPremium", { isPremium: false, message: "No user logged in", premiumId: null, grantedByAdmin: false, isPremiumTrial: false });
        return { isPremium: false, message: "No user logged in", premiumId: null, grantedByAdmin: false, isPremiumTrial: false };
    }
    if (!user.idPost) {
        appStore.set("calooPremium", { isPremium: false, message: "No user logged in", premiumId: null, grantedByAdmin: false, isPremiumTrial: false });
        return { isPremium: false, message: "User ID not found", premiumId: null, grantedByAdmin: false, isPremiumTrial: false };
    }
    const serverPremium = await checkPremiumSE(user.idPost, user.firebaseUser);
    if (serverPremium.isPremium) {
        console.log(`✅ User ${user.idPost} is subscribed to a premium product (REMOTE): ${serverPremium.productId}`);
        appStore.set("calooPremium", serverPremium);
        return serverPremium;
    }
    console.log(`ℹ️ User ${user.idPost} is not subscribed to a premium product, checking local subscriptions...`);
    const paymentSubscribed = checkAnyActiveSubscription(CalooAdminConfig.storesProducts || []);
    if (paymentSubscribed.isPremium) {
        console.log(`✅ User ${user.idPost} is subscribed to a premium product  LOCAL): ${paymentSubscribed.productId}`);
        appStore.set("calooPremium", paymentSubscribed);
        return paymentSubscribed;
    }
    const allowedPremiums = CalooAdminConfig.premiums || [];
    const allowedPremium = checkPremiumAccess(allowedPremiums, user.idPost, user.firebaseUser);
    appStore.set("calooPremium", allowedPremium);
    return allowedPremium;
}

/**
 * Comprueba si el usuario tiene acceso premium.
 *
 * @param allowedPremiums - Array de arrays [[key, premiumId]]
 * @param userIdPost - El idPost del usuario
 * @returns { isPremium: boolean, premiumId: string | null }
 */
function checkPremiumAccess(allowedPremiums: [string, string][], userIdPost: string, userIdFirebase: string): { isPremium: boolean; premiumId: string | null; grantedByAdmin: boolean; isPremiumTrial: boolean } {
    for (const [key, premiumId] of allowedPremiums) {
        if (key === '*' || key === userIdPost || key === userIdFirebase) {
            console.log(`✅ Acceso premium concedido para ${key} con ID: ${premiumId}`);
            return {
                isPremium: true,
                premiumId,
                grantedByAdmin: true,
                isPremiumTrial: false
            };
        }
    }

    return {
        isPremium: false,
        premiumId: null,
        grantedByAdmin: false,
        isPremiumTrial: false
    };
}

/**
 * Comprueba si el usuario está suscrito a alguno de los productos de la lista.
 * 
 * @param storeProducts - Array de arrays [productId, type, description]
 * @returns { isPremium: boolean, productId: string | null }
 */
export function checkAnyActiveSubscription(storeProducts: [string, string, string][]): { isPremium: boolean; productId: string | null; grantedByAdmin: boolean; isPremiumTrial: boolean; } {
    try {
        for (const [productId] of storeProducts) {
            if (isSubscribed(productId)) {
                console.log(`✅ Suscripción activa encontrada: ${productId}`);
                return {
                    isPremium: true,
                    productId, grantedByAdmin: false,
                    isPremiumTrial: false
                };
            }
        }
        console.log("ℹ️ No se encontró ninguna suscripción activa.");
        return {
            isPremium: false,
            productId: null,
            grantedByAdmin: false,
            isPremiumTrial: false
        };
    } catch (error) {
        console.error("❌ Error comprobando suscripciones:", error);
        return {
            isPremium: false,
            productId: null,
            grantedByAdmin: false,
            isPremiumTrial: false
        };
    }
}
const BASE_URL =
    CalooAdminConfig?.googleApi ||
    import.meta.env.VITE_MEEFOD_API_URL;

export async function setPurchaseSE(uid: any, purchase: any) {
    try {
        console.log("📦 Setting purchase for user:", uid, "with data:", JSON.stringify(purchase));
        const response = await requestSE(uid).post(
            `${BASE_URL}/v2/set/purchase`,
            { purchase }
        );
        console.log("📦 Purchase set response:", response.data);
        return response.data;
    } catch (error) {
        logEvent(`❌ Error setting purchase: ${JSON.stringify(error)}`);
    }
}


export async function checkPremiumSE(idPost: string, userIdFirebase: string) {
    try {
        const response = await requestSE(userIdFirebase).get(
            `${BASE_URL}/caloo/check/premium`,
        );
        console.log("📦 Premium check response:", response.data);
        return response.data;
    } catch (error) {
        logEvent(`❌ Error checking premium status: ${JSON.stringify(error)}`);
        return { isPremium: false, productId: null, grantedByAdmin: false };
    }
}

export async function checkPromotionalCodeSE(uid: string, code: string) {
    try {
        const response = await requestSE(uid).get(
            `${BASE_URL}/get/checkpromotionalcode/${code}`
        );
        console.log("🏷️ Promo code check response:", response.data);
        return response.data;
    } catch (error) {
        logEvent(`❌ Error checking promo code: ${JSON.stringify(error)}`);
        return null; // o un objeto tipo { valid: false } si prefieres
    }
}